import React, { useState } from "react";

export default function useModalHandler() {
    const [visible, setVisible] = useState(false);
    const [closed, setClosed] = useState(true);

    function close() {
        setVisible(false);
    }

    function open() {
        setVisible(true);
        setClosed(false);
    }

    function afterClose() {
        setClosed(true);
    }

    /**
     * render输出的组件会在关闭后自动清理
     * 注意render方法会接管组件的visible, afterClose, onCancel三个属性.
     * @param children
     */
    function render(children: React.ReactElement) {
        const handleCancel = () => {
            close();
            children.props?.onCancel?.();
        };

        const handleAfterClose = () => {
            afterClose();
            children.props?.afterClose?.();
        };

        return (
            !closed &&
            React.cloneElement(children, {
                visible,
                afterClose: handleAfterClose,
                onCancel: handleCancel
            })
        );
    }

    return { visible, setVisible, close, open, closed, afterClose, render };
}
